import { defineStore, acceptHMRUpdate } from 'pinia'
import { post , exchangeToken, authenticateToken, logout} from '@/services/webservice'
import {getCurrentUser} from "@/services/entityService"
import {subsystemUrls, healthcheckFrequency} from '@/config'
import {useLogger} from "@/composables/useLogger"
import {usePathController} from "@/composables/usePathController"
const {sendLog} = useLogger() 

export const useUserStore = defineStore('userstore', {
  state: () => ({
    userInfo: null,
    challengeMetadata: null,
    approvedSubsystems: [],
    timerId: null,
  }),
  getters: {
    isPasswordExpired(state){
      return state.userInfo.needsReset
    },
    userId(state){
      return state.userInfo?._id
    },
    isSysAdmin(state){
      if (!state.userInfo) {
        return false
      }
      const accessLevel = state.userInfo.accessLevel
      return accessLevel === 'SysAdmin'
    },
    accesslevel(state){
      if (!state.userInfo) {
        return null
      }
      return state.userInfo.accessLevel
    },
    approvedSubsystem(state){
      if(!state.userInfo) return []
      return state.userInfo.subsystemAccess.map(subsystem => ({
        title: subsystem, 
        description: `Access ${subsystem} service`, 
        routeTo: subsystemUrls[subsystem]
      }))
    },
    
    challengeMetadataBody(state){
      if(!state.challengeMetadata) return []
      return state.challengeMetadata?.body
    }
  },
  actions: {
    setAuthInitialized(value) {
      this.authInitialized = value
    },
    handleRedirect(response){
      const {redirectSubsystem = null, landingPath = null} = response
      if(redirectSubsystem && landingPath){
        const redirectUrl = subsystemUrls[redirectSubsystem] + landingPath
      }
    },
    async handlePostLogin(){
      const {logoutCoordinator} = usePathController()
            this.challengeMetadata = {}
            await this.getCurrentUser(true)
            const timerId = setInterval(async () => {
              try {
                await authenticateToken()
              } catch (error) {
                if (error?.status === 401) {
                  clearInterval(timerId)
                  logoutCoordinator()
                }
              }
            }, healthcheckFrequency)
            this.setTimerId(timerId)
    },

    async login(loginData) {
      const {data = null} = await post('/login', loginData)
        if (data?.success) {
            await this.handlePostLogin()
            // this.setApprovedSubsystems(subsystems || [])
            return true

        } else if(data?.state === "challenge"){
          this.challengeMetadata = {}
          this.challengeMetadata.body = data
          this.challengeMetadata.name = data.challengeName
          return true
        }

        return false
    },

    async answerChallenge(challengeData){
      const {data} = await post("/answerChallenge", challengeData)
      if(data?.domain && data?.path) return data
      else await this.handlePostLogin()
    },

    async setupMFAAPP(challengeData){
      const payloadFormat = {
          "accessToken": challengeData.accessToken,
          "userCode": challengeData.userCode,
          "redirectSubsystem": challengeData?.redirectSubsystem,
          "landingPath": challengeData.landingPath,
        }
      const {data} = await post("/verifyTotpToken", payloadFormat)
      if(data?.domain && data?.path) return data
      else await this.handlePostLogin()
    },

    async getCurrentUser(force = false) {
      sendLog("info", "get_current_user", {isForce:force})
      if(this.userInfo && !force) return Promise.resolve(this.userInfo)  
      const data = await getCurrentUser()
      this.userInfo = data
    },
    setTimerId(timerId) { 
      this.timerId = timerId 
    },  
    clearAllData() {
      this.approvedSubsystems = []
      this.timerId = null
      this.userInfo = null
      this.challengeMetadata = null
    }
  }
})

if(import.meta.webpackHot) {
  import.meta.webpackHot.accept(
    acceptHMRUpdate(useUserStore, import.meta.hot))
}
